import { z } from "zod";

export const updateEquipmentStocksSchema = z.object({
  quantityLeft: z.coerce.number().min(0),
  quantityRented: z.coerce.number().min(0),
});

export const defaultUpdateEquipmentStocksValues = {
  quantityLeft: 0,
  quantityRented: 0,
};

export type UpdateEquipmentStocksForm = z.infer<
  typeof updateEquipmentStocksSchema
>;
